/**
 * i18next initialization.
 *
 * Locales: fr (default), ar, en. Language is driven by the PreferencesContext;
 * we do not auto-detect from the browser to keep behavior deterministic.
 *
 * RTL direction is handled by PreferencesContext (sets <html dir>).
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

export const SUPPORTED_LANGUAGES = ['fr', 'ar', 'en'];
export const DEFAULT_LANGUAGE = 'fr';
export const RTL_LANGUAGES = new Set(['ar']);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ar: { translation: ar },
    },
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
